/* =============================================================================
   THE WOMAN WHO RECEIVES — shared front-end behaviour
   Idempotent: safe to run again after a Shopify theme-editor section reload.
   ========================================================================== */
(function () {
  'use strict';

  var DONE = 'twwrBound';

  /* ---------------------------------------------------------------------- */
  /* Modals                                                                  */
  /* ---------------------------------------------------------------------- */
  var lastFocused = null;

  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closer = modal.querySelector('[data-twwr-close]');
    if (closer) closer.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    if (!document.querySelector('.tw-modal.is-open')) document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function bindModals() {
    document.querySelectorAll('[data-twwr-open]').forEach(function (btn) {
      if (btn.dataset[DONE]) return;
      btn.dataset[DONE] = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(btn.getAttribute('data-twwr-open'));
      });
    });

    document.querySelectorAll('.tw-modal').forEach(function (modal) {
      if (modal.dataset[DONE]) return;
      modal.dataset[DONE] = '1';
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.closest('[data-twwr-close]')) closeModal(modal);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tw-modal.is-open');
    if (open) closeModal(open);
  });

  /* ---------------------------------------------------------------------- */
  /* Rotating proof line                                                     */
  /* ---------------------------------------------------------------------- */
  function bindProof() {
    document.querySelectorAll('[data-twwr-proof]').forEach(function (el) {
      if (el.dataset[DONE]) return;
      el.dataset[DONE] = '1';

      var msgs = (el.getAttribute('data-messages') || '')
        .split('\n')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
      if (msgs.length < 2) return;

      var i = 0;
      setInterval(function () {
        el.classList.add('is-out');
        setTimeout(function () {
          i = (i + 1) % msgs.length;
          el.textContent = msgs[i];
          el.classList.remove('is-out');
          el.classList.add('is-in');
          void el.offsetHeight;               // force reflow so the transition runs
          el.classList.remove('is-in');
        }, 320);
      }, 3800);
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Live visitor counter                                                    */
  /* ---------------------------------------------------------------------- */
  function bindViewers() {
    document.querySelectorAll('[data-twwr-viewers]').forEach(function (el) {
      if (el.dataset[DONE]) return;
      el.dataset[DONE] = '1';

      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min)) min = 74;
      if (isNaN(max)) max = 186;
      if (max <= min) max = min + 40;

      function clamp(n) { return Math.max(min, Math.min(max, n)); }

      var current = clamp(min + Math.floor(Math.random() * (max - min + 1)));
      el.textContent = current;

      setInterval(function () {
        var drift = Math.floor(Math.random() * 9) - 4;   // -4 .. +4
        if (current + drift <= min) drift = Math.abs(drift) + 1;
        if (current + drift >= max) drift = -Math.abs(drift) - 1;
        current = clamp(current + drift);
        el.textContent = current;
      }, 6000 + Math.floor(Math.random() * 4000));
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Carousel                                                                */
  /* ---------------------------------------------------------------------- */
  function bindCarousels() {
    document.querySelectorAll('[data-twwr-carousel]').forEach(function (root) {
      if (root.dataset[DONE]) return;
      root.dataset[DONE] = '1';

      var track = root.querySelector('[data-twwr-track]');
      var prev = root.querySelector('[data-twwr-prev]');
      var next = root.querySelector('[data-twwr-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.twwr-car__slide');
        if (!slide) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function sync() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Reviews — filter, show more, detail modal                               */
  /* ---------------------------------------------------------------------- */
  function bindReviews() {
    document.querySelectorAll('[data-twwr-reviews]').forEach(function (root) {
      if (root.dataset[DONE]) return;
      root.dataset[DONE] = '1';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-twwr-review]'));
      var moreBtn = root.querySelector('[data-twwr-more]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-twwr-filter]'));
      var totalEl = root.querySelector('[data-twwr-shown]');
      var emptyEl = root.querySelector('[data-twwr-noresults]');
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 6;

      var filter = 'all';
      var shown = perPage;

      function matches(card) {
        if (filter === 'all') return true;
        if (filter === 'photos') return card.getAttribute('data-has-photo') === '1';
        return (card.getAttribute('data-edition') || '').toLowerCase().indexOf(filter) !== -1;
      }

      function render() {
        var visible = 0;
        var pool = 0;
        cards.forEach(function (card) {
          if (!matches(card)) { card.classList.add('is-hidden'); return; }
          pool++;
          if (visible < shown) { card.classList.remove('is-hidden'); visible++; }
          else { card.classList.add('is-hidden'); }
        });
        if (moreBtn) moreBtn.style.display = pool > visible ? '' : 'none';
        if (totalEl) totalEl.textContent = visible;
        if (emptyEl) emptyEl.style.display = pool === 0 ? '' : 'none';
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          filter = chip.getAttribute('data-twwr-filter');
          shown = perPage;
          render();
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', function () { shown += perPage; render(); });
      }

      /* open a review in the modal */
      var modal = root.querySelector('[data-twwr-review-modal]');
      if (modal) {
        var mAvatar = modal.querySelector('[data-m-avatar]');
        var mName = modal.querySelector('[data-m-name]');
        var mMeta = modal.querySelector('[data-m-meta]');
        var mStars = modal.querySelector('[data-m-stars]');
        var mTitle = modal.querySelector('[data-m-title]');
        var mText = modal.querySelector('[data-m-text]');
        var mProof = modal.querySelector('[data-m-proof]');
        var mHelpful = modal.querySelector('[data-m-helpful]');

        cards.forEach(function (card) {
          card.addEventListener('click', function () {
            var name = card.getAttribute('data-name') || '';
            var photo = card.getAttribute('data-avatar') || '';
            var stars = parseInt(card.getAttribute('data-stars'), 10) || 5;

            if (mAvatar) {
              mAvatar.innerHTML = photo
                ? '<img src="' + photo + '" alt="" loading="lazy">'
                : (name.trim().charAt(0) || '?');
            }
            if (mName) mName.textContent = name;
            if (mMeta) {
              mMeta.innerHTML =
                '<span class="twwr-review__verified">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
                'Verified buyer</span>' +
                '<span class="twwr-review__sep">&middot;</span>' +
                '<span>' + (card.getAttribute('data-edition') || '') + '</span>' +
                '<span class="twwr-review__sep">&middot;</span>' +
                '<span>' + (card.getAttribute('data-date') || '') + '</span>';
            }
            if (mStars) mStars.textContent = '★'.repeat(stars) + '☆'.repeat(5 - stars);
            if (mTitle) mTitle.textContent = card.getAttribute('data-title') || '';
            if (mText) mText.textContent = card.getAttribute('data-text') || '';
            if (mProof) {
              var proof = card.getAttribute('data-proof') || '';
              mProof.innerHTML = proof ? '<img src="' + proof + '" alt="Reader photo" loading="lazy">' : '';
              mProof.style.display = proof ? '' : 'none';
            }
            if (mHelpful) mHelpful.textContent = (card.getAttribute('data-helpful') || '0') + ' people found this helpful';

            openModal(modal.id);
          });
        });

        /* photo strip in the summary jumps straight into that review */
        root.querySelectorAll('[data-twwr-jump]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var target = root.querySelector('[data-twwr-review][data-key="' + btn.getAttribute('data-twwr-jump') + '"]');
            if (target) target.click();
          });
        });
      }

      render();
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Community image lightbox                                                */
  /* ---------------------------------------------------------------------- */
  function bindCommunity() {
    document.querySelectorAll('[data-twwr-community]').forEach(function (root) {
      if (root.dataset[DONE]) return;
      root.dataset[DONE] = '1';

      var modal = root.querySelector('[data-twwr-com-modal]');
      if (!modal) return;
      var holder = modal.querySelector('[data-com-image]');

      root.querySelectorAll('[data-com-src]').forEach(function (cell) {
        cell.addEventListener('click', function () {
          var src = cell.getAttribute('data-com-src');
          if (!src || !holder) return;
          holder.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
          openModal(modal.id);
        });
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Sticky edition bar                                                      */
  /* ---------------------------------------------------------------------- */
  function bindSticky() {
    var bar = document.querySelector('[data-twwr-sticky]');
    if (!bar || bar.dataset[DONE]) return;
    bar.dataset[DONE] = '1';

    /* --- show / hide --- */
    var afterSel = bar.getAttribute('data-after');
    var anchor = afterSel ? document.querySelector(afterSel) : null;

    function check() {
      var show;
      if (anchor) {
        show = anchor.getBoundingClientRect().bottom < 0;
      } else {
        show = window.scrollY > 600;
      }
      /* never cover the footer */
      var footer = document.querySelector('.footer');
      if (show && footer && footer.getBoundingClientRect().top < window.innerHeight - 40) show = false;

      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();

    /* --- edition tabs --- */
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-st-tab]'));
    var priceEl = bar.querySelector('[data-st-price]');
    var variantEl = bar.querySelector('[data-st-variant]');
    var imgEl = bar.querySelector('[data-st-img]');
    var form = bar.querySelector('[data-st-form]');
    var link = bar.querySelector('[data-st-link]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        var price = tab.getAttribute('data-price');
        var variant = tab.getAttribute('data-variant');
        var img = tab.getAttribute('data-img');
        var url = tab.getAttribute('data-url');

        if (price && priceEl) priceEl.textContent = price;
        if (imgEl && img) imgEl.src = img;
        if (link && url) link.href = url;

        /* a real variant id means we can add to cart straight from the bar;
           otherwise the CTA falls back to opening that edition's page */
        if (variant && variantEl && form) {
          variantEl.value = variant;
          form.style.display = '';
          if (link) link.style.display = 'none';
        } else if (link) {
          if (form) form.style.display = 'none';
          link.style.display = '';
        }
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  function init() {
    bindModals();
    bindProof();
    bindViewers();
    bindCarousels();
    bindReviews();
    bindCommunity();
    bindSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor re-renders sections without a page reload */
  document.addEventListener('shopify:section:load', init);
})();
